import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import React from "react";

import { Reports } from "./reports";

export const ReportsTab = (): JSX.Element => {
  const WrappedTab = usePageWrapper(Reports);
  return <WrappedTab />;
};
